import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Bar from '../../../../../common/chart/chartContainer/Bar'
import Line from '../../../../../common/chart/chartContainer/Line'
import { MARGIN_CHART } from '../../../../../common/chart/chartContainer/constants'
import { Legend } from '../../../../../common/chart/legend'
import { Element } from '../../../../../common/html/element'
import { Loading } from '../../../../../common/loading'
import { Notification } from '../../../../../common/notification'
import { formatVal } from '../../../../../helpers/value'
import { selectCompanyInfo } from '../../../../common/header/companyInfo/store/slice'
import { CustomTooltip } from '../../../../industry/industryOverview/macroeconomics/customTooltip'
import { selectListChartScore, selectScoreIsLoading } from '../store/slice'

export const ChartContent = ({ dataChart }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const { organizationId, organizationName } = useSelector(selectCompanyInfo)
  const listChartScore = useSelector(selectListChartScore)
  const isLoading = useSelector(selectScoreIsLoading)

  const orgIds = listChartScore.map((item) => item.val)
  const orgList = Object.values(dataChart).filter((item) => {
    return orgIds.includes(item.col1)
  })

  const objData = {}
  const chartDataLabel = Object.keys(dataChart[organizationId] || {})
  chartDataLabel.splice(chartDataLabel.length - 2, 2)

  const chartLabel = [...chartDataLabel]
  if (chartDataLabel.length > 0 && chartDataLabel.length < 5) {
    for (let i = 0; i < 5 - chartDataLabel.length; i++) {
      chartLabel.push(parseInt(chartLabel[chartLabel.length - 1]) + 1 + '')
    }
  }

  const barChart = chartLabel.map((i) => {
    return {
      label: i,
      data: dataChart[organizationId][i]
        ? dataChart[organizationId][i].value
        : null,
    }
  })

  const lineChart = orgIds.map((item) => {
    return chartLabel.map((i) => {
      const dataItem = dataChart?.[item] || undefined
      return {
        label: i,
        data: dataItem ? dataItem[i].value : undefined,
      }
    })
  })

  const dataFormat = lineChart.map((item) => {
    let obj = {}

    item.forEach((i) => {
      obj[i.label] = i.data
    })

    return obj
  })

  dataFormat[0] &&
    Object.keys(dataFormat[0]).forEach((key) => {
      dataFormat.forEach((item) => {
        objData[key] = [...(objData[key] || []), item[key]]
      })
    })

  const fullData = barChart.map((item) => {
    const eachYear = objData[item.label] || []
    const obj = {}

    eachYear.forEach((i, index) => {
      obj['line' + index] = i
    })

    return {
      ...item,
      ...obj,
    }
  })

  if (isLoading) {
    return (
      <div className="h100 positionRelative">
        <Loading />
      </div>
    )
  }

  if (!fullData.length) {
    return <Notification />
  }

  return (
    <div className="flexColumn h100">
      <ChartContainer
        data={fullData}
        width={'100%'}
        height={330}
        margin={{ ...MARGIN_CHART, left: 0 }}
        yAxis={[
          {
            yAxisId: 'left',
            dataKeys: ['data', ...orgList.map((_, index) => 'line' + index)],
            isBarChart: true,
            tickFormatter: (val) => formatVal(val),
          },
        ]}
        xAxis={[{ dataKey: 'label' }]}
        tooltip={{
          maxWidth: 300,
          schema: {
            renderCustomContent: ({ data = {} }) => {
              return (
                <CustomTooltip
                  label={data.label}
                  list={[
                    {
                      label: organizationName,
                      value: formatVal(data.data, locale),
                    },
                    ...orgList.map((item, index) => ({
                      label: item.organizationName,
                      value: formatVal(data['line' + index], locale),
                    })),
                  ]}
                />
              )
            },
          },
        }}
      >
        <Bar yAxisId="left" dataKey={'data'} fill="#006AA6" barSize={32} />
        {orgList.map((item, index) => {
          const { color } =
            listChartScore.find((i) => i.val === item.col1) || {}
          return (
            <Line
              key={index}
              yAxisId="left"
              dataKey={`line${index}`}
              stroke={color}
              fill={color}
            />
          )
        })}
      </ChartContainer>

      <Legend
        items={[
          {
            color: '#006AA6',
            title: organizationName,
            isI18n: false,
          },
        ]}
      />
      {listChartScore.length > 0 && (
        <div style={{ margin: '4px 0' }}>
          <Translate
            value="companyAnalysis.peerAnalysis.SELECTED_PEERS"
            className="fw600"
          />
        </div>
      )}
      <Legend
        className="flexColumn"
        items={listChartScore.map((item) => ({
          key: item.val,
          color: item.color,
          title:
            orgList.find((i) => i.col1 === item.val)?.organizationName || '',
          iconCustom: true,
          isEllipsis: true,
          isI18n: false,
          renderCustomIcon: () => {
            return (
              <Element
                style={{
                  height: 4,
                  width: 12,
                  backgroundColor: item.color,
                  cursor: 'default',
                }}
              />
            )
          },
        }))}
      />
    </div>
  )
}
